import ServiceBase from './ServiceBase'
import type { Currency } from '@/types/Currency'

interface CurrencyListResult {
  currencies: Currency[]
  current: string
}

function mapCurrency(raw: any): Currency {
  return {
    currencyId: Number(raw.currency_id),
    code: raw.code,
    title: raw.title,
    symbolLeft: raw.symbol_left,
    symbolRight: raw.symbol_right,
    decimalPlace: Number(raw.decimal_place),
    value: Number(raw.value)
  }
}

class CurrencyService extends ServiceBase {
  async getCurrencies(): Promise<CurrencyListResult> {
    return new Promise((resolve, reject) => {
      this.webGet(
        {},
        (result: any) => {
          resolve({
            currencies: (result?.currencies ?? []).map(mapCurrency),
            current: result?.current
          })
        },
        'api/currency/list',
        (error: any) => reject(error),
        5000,
        2
      )
    })
  }

  // Country and city of the visitor's IP, resolved by our backend (api/geo/country).
  // Never throws: { country: '', city: '' } when unknown.
  async getGeoByIp(): Promise<{
    country: string
    city: string
    lat: number | null
    lon: number | null
    nearbyKm: number | null
  }> {
    return new Promise((resolve) => {
      this.webGet(
        {},
        (result: any) =>
          resolve({
            country: String(result?.country ?? '').toUpperCase(),
            city: String(result?.city ?? ''),
            lat: result?.lat == null ? null : Number(result.lat),
            lon: result?.lon == null ? null : Number(result.lon),
            nearbyKm: result?.nearby_km == null ? null : Number(result.nearby_km)
          }),
        'api/geo/country',
        () => resolve({ country: '', city: '', lat: null, lon: null, nearbyKm: null }),
        3000,
        1
      )
    })
  }

  async setCurrency(code: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.webPost(
        { code },
        (result: any) => {
          if (result?.success) {
            resolve(result.current)
          } else {
            reject(new Error(result?.error || 'Failed to set currency'))
          }
        },
        'api/currency/set',
        (error: any) => reject(error),
        5000,
        1
      )
    })
  }
}

export default new CurrencyService()
